import { TableCols } from "../interfaces/static-data";

export const UNDERLYINGS: TableCols[] = [
  {
    key: 'referenceAsset',
    displayValue: 'Reference Asset',
    type: 'select',
  },
  {
    key: 'market',
    displayValue: 'Market',
  },
  {
    key: 'indexDescription',
    displayValue: 'Index Description',
  },
  {
    key: 'indexDisclosure',
    displayValue: 'Index Disclosure',
  },
  {
    key: 'indexProviderWebsite',
    displayValue: 'Index Provider Website',
  },
  {
    key: 'exchangeWebsite',
    displayValue: 'Exchange Website',
  },
];
